module.exports = __webpack_public_path__ + "static/media/about-certificate-img3.fd026104.jpg";